export const MessagesConfig: IMessagesConfig = {
    threadRefreshIntervalInSeconds: 10,
    messageRefreshIntervalInSeconds: 5,

    useReadByClients: true,
    useEmojis: true,

    topbar: {
        button: false,
        dialog: true,
        openThreadInDialog: true,
    },

    libraryFileUpload: {
        enabled: true,
    },
    localFileUpload: {
        enabled: true,
    },

    videoCall: {
        enabled: true,
    },

    notifications: {
        push: {
            enabled: false,
            sendAsParallell: true,
        },
    },
};

export interface IMessagesConfig {
    threadRefreshIntervalInSeconds: number;
    messageRefreshIntervalInSeconds: number;

    useReadByClients?: boolean;
    useEmojis?: boolean;

    topbar: {
        button: boolean;
        dialog: boolean;
        openThreadInDialog: boolean;
    };

    libraryFileUpload?: {
        enabled: boolean;
    };

    localFileUpload?: {
        enabled: boolean;
    };

    notifications?: {
        push?: {
            enabled: boolean;
            title?: string;
            body?: string;

            // If true, the push will not be baked in to the message request, but sent in parallell
            sendAsParallell?: boolean;
        };
        internal?: {
            enabled: boolean;
        };
    };

    videoCall?: {
        enabled: boolean;
        requiredPermissions?: string | string[];
    };
}
